module.exports = __webpack_public_path__ + "static/media/2012_ped_care.dcfbbc76.gif";